import React from 'react';
import {Box, Grid, Typography} from '@deere/fuel-react';
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {useStyles} from "../shared/styles/Ratings";

export const RatingPgmPublishSubCatCard = ({subCategory, totalSelected, selectedCriteria}) => {
    const classes = useStyles();
    return (
        <AccordionSummary
            className={classes.accordionSummary}
            classes={{
                expandIcon: classes.expandIcon,
                content: classes.content,
                expanded: classes.expanded,
                disabled: classes.disabled
            }}
            expandIcon={<ExpandMoreIcon/>}
            style={{alignItems: 'center'}}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
        >
            <Grid container alignItems="center">
                <Grid item xs={10}>
                    <Box display="flex"
                         justifyContent="flex-start">
                        <Typography
                            fontWeight="semibold" size="md">
                            {subCategory.description}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <Box display="flex"
                         justifyContent="flex-start" pl={4}>
                        <Typography
                            color="primary" size="md">
                            {totalSelected}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <Box display="flex"
                         justifyContent="flex-start" pl={4}>
                        <Typography
                            color="primary" size="md">
                            {`${subCategory.weight}%`}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </AccordionSummary>
    )
}